<template>
  <li class="reply-templates-category-list-item" v-if="category">
    <div class="reply-templates-category-list-item__category-name">
      {{ category.name }}
    </div>
    <div class="reply-templates-category-list-item__replies-count">
      {{ category.templates_count || 0 }}
    </div>
    <div class="reply-templates-category-list-item__date">
      <!-- <p>{{ category.author }}</p>
      <p>{{ updatedTime }}</p> -->
    </div>
    <div class="reply-templates-category-list-item__actions">
      <v-btn icon color="primary" @click="editCategory" class="mr-2">
        <v-icon>
          icon-edit
        </v-icon>
      </v-btn>
      <v-btn icon color="pink" @click="deleteCategory" class="mr-2">
        <v-icon>
          icon-trash
        </v-icon>
      </v-btn>
      <ui-button transparent small @click="goToReplies">
        {{ $t("message.reviews.replyTemplates.categories.viewButton") }}
      </ui-button>
    </div>
  </li>
</template>

<script>
import moment from "moment";
import { FORMAT } from "@/config/date-format";

export default {
  name: "ReplyTemplatesCategoryListItem",
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    updatedTime() {
      return this.category && this.category.updated_at
        ? moment(this.category.updated_at).format(FORMAT.DATE_HM)
        : "-";
    }
  },
  methods: {
    editCategory() {
      this.$emit("edit", this.category);
    },
    deleteCategory() {
      this.$emit("delete", this.category);
    },
    goToReplies() {
      this.$emit("goToReplyTemplates", this.category);
    }
  }
};
</script>

<style lang="scss" scoped>
.reply-templates-category-list-item {
  display: flex;
  justify-content: space-between;
  padding-left: $spacing * 2;
  border-left: 3px solid $light-3;
  margin-bottom: $spacing * 1.5;
  font-weight: 500;
  color: $text;
  min-height: 52px;
  transition: background 0.15s ease;
  border-radius: 0 25px 25px 0;

  &:hover {
    background-color: $light-4;
  }

  &__category-name,
  &__replies-count,
  &__date,
  &__actions {
    display: flex;
    align-items: center;
    padding-right: $spacing;
  }

  &__category-name,
  &__actions {
    width: 30%;
  }

  &__replies-count,
  &__date {
    width: 20%;
  }

  &__date {
    flex-direction: column;
    align-items: flex-start;

    p {
      margin-bottom: 0;

      &:last-child {
        font-weight: 400;
      }
    }
  }

  &__actions {
    justify-content: flex-end;

    button:last-child {
      @include font-size(14px);
      font-weight: 600;
      text-decoration: underline;
      margin-right: $spacing * 0.5;
    }
  }
}
</style>
